// Lists contents
export const linksItems = (links) => {
  return [
    {
      text: "termos de uso e privacidade",
      link: links?.urlPrivacityPage ?? "https://www.itau.com.br/privacidade/",
    },
    {
      text: "segurança",
      link: links?.urlSecurityPage ?? "https://www.itau.com.br/seguranca/",
    },
    {
      text: "precisa de ajuda?",
      link:
        links?.urlHelpPage ??
        "https://www.itau.com.br/atendimento-itau/para-voce/cartao-de-credito/",
    },
  ]
}

export const socialItems = [
  {
    icon: `<svg aria-hidden="true" id="instagram-footer" class="icon" width="22" height="20" fill="none">
		<path d="M13.836 7.18c.375.375.664.804.867 1.289a3.9 3.9 0 0 1 .305 1.523c0 .531-.102 1.047-.305 1.547a3.989 3.989 0 0 1-.867 1.29c-.39.374-.828.663-1.313.866A3.9 3.9 0 0 1 11 14a3.9 3.9 0 0 1-1.523-.305 4.264 4.264 0 0 1-1.313-.867 3.99 3.99 0 0 1-.867-1.289 4.074 4.074 0 0 1-.305-1.547 3.9 3.9 0 0 1 .305-1.523c.203-.485.492-.914.867-1.29.39-.39.828-.679 1.313-.867A3.9 3.9 0 0 1 11 6.008a3.9 3.9 0 0 1 1.523.304 3.77 3.77 0 0 1 1.313.868ZM21.008 5v10.008c0 .687-.133 1.336-.399 1.945a5.206 5.206 0 0 1-1.078 1.57 5.126 5.126 0 0 1-1.593 1.079 4.816 4.816 0 0 1-1.946.398H6.008a4.816 4.816 0 0 1-1.946-.398 5.127 5.127 0 0 1-2.671-2.649 4.815 4.815 0 0 1-.399-1.945V5c0-.688.133-1.336.399-1.945.265-.61.625-1.14 1.078-1.594A4.81 4.81 0 0 1 4.063.406 4.815 4.815 0 0 1 6.008.008h9.984c.688 0 1.336.133 1.945.398.61.25 1.141.602 1.594 1.055.453.453.813.984 1.078 1.594.266.61.399 1.257.399 1.945Zm-5.016 4.992c0-.687-.125-1.336-.375-1.945a4.848 4.848 0 0 0-1.078-1.57 5.128 5.128 0 0 0-1.594-1.079A4.815 4.815 0 0 0 11 5c-.688 0-1.336.133-1.945.398-.61.266-1.14.625-1.594 1.079-.453.437-.813.96-1.078 1.57a5.075 5.075 0 0 0-.375 1.945c0 .703.125 1.352.375 1.945.265.61.625 1.141 1.078 1.594.453.453.984.813 1.594 1.078.61.266 1.258.399 1.945.399.688 0 1.336-.133 1.945-.399a5.126 5.126 0 0 0 1.594-1.078 5.126 5.126 0 0 0 1.078-1.594c.25-.593.375-1.242.375-1.945Zm1.008-6a.892.892 0 0 0-.305-.68.917.917 0 0 0-.703-.304c-.265 0-.5.101-.703.304a.926.926 0 0 0-.281.68c0 .281.094.524.281.727.203.187.438.281.703.281a.954.954 0 0 0 .703-.281.992.992 0 0 0 .305-.727Z" fill="#D6D0CC"/>
	</svg>`,
    link: "https://www.instagram.com/itau",
    alt: "logo instagram",
  },

  {
    icon: `<svg aria-hidden="true" id="youtube-footer" width="21" height="20" fill="none">
		<path d="M10.286.008A9.882 9.882 0 0 0 6.395.78a10.254 10.254 0 0 0-3.187 2.156 10 10 0 0 0-2.133 3.165 9.63 9.63 0 0 0-.797 3.89c0 1.39.265 2.688.797 3.89a9.928 9.928 0 0 0 2.133 3.188 9.928 9.928 0 0 0 3.187 2.133 9.63 9.63 0 0 0 3.89.797 9.63 9.63 0 0 0 3.891-.797 9.93 9.93 0 0 0 3.188-2.133 9.929 9.929 0 0 0 2.133-3.187c.53-1.203.797-2.5.797-3.89a9.631 9.631 0 0 0-.797-3.891 10 10 0 0 0-2.133-3.165A10.255 10.255 0 0 0 14.176.781a9.882 9.882 0 0 0-3.89-.773ZM8.293 14V6.008l6.985 3.984L8.293 14Z" fill="#D6D0CC"/>
	</svg>`,
    link: "https://www.youtube.com/itau",
    alt: "logo youtube",
  },
  {
    icon: `<svg aria-hidden="true" id="facebook-footer" width="21" height="20" fill="none">
		<path d="M20.58.617v18.375a.992.992 0 0 1-.305.727.954.954 0 0 1-.703.281h-5.204v-7.734h2.602l.398-3.024h-3V7.32c0-.437.094-.789.282-1.054.187-.282.593-.422 1.218-.422h1.594V3.148c-.14-.03-.43-.054-.867-.07a19.914 19.914 0 0 0-1.453-.047c-1.156 0-2.094.344-2.813 1.031-.718.672-1.078 1.657-1.078 2.954v2.226H8.65v3h2.601V20h-9.68c-.28 0-.523-.094-.726-.281a1.035 1.035 0 0 1-.281-.727v-18C.564.727.657.5.845.312a.992.992 0 0 1 .727-.304h18.375c.171 0 .32.062.445.187.125.11.187.25.187.422Z" fill="#D6D0CC"/>
	</svg>`,
    link: "https://www.facebook.com/itau",
    alt: "logo facebook",
  },
  {
    icon: `<svg aria-hidden="true" id="twitter-footer" width="19" height="14" fill="none">
		<path d="M17.006 3.64c.015.079.023.157.023.235v.234a9.928 9.928 0 0 1-.68 3.61 9.83 9.83 0 0 1-2.039 3.187c-.89.922-1.984 1.664-3.28 2.227-1.313.578-2.821.867-4.524.867-1.032 0-2.032-.11-3-.328a8.854 8.854 0 0 1-2.649-1.125l.422.047h.469c.86 0 1.68-.102 2.46-.305a5.591 5.591 0 0 0 2.11-1.055 4.097 4.097 0 0 1-2.156-.632c-.64-.422-1.078-1-1.313-1.735.125.031.29.055.493.07h.515c.156 0 .313-.007.469-.023.172-.031.336-.062.492-.094a3.625 3.625 0 0 1-2.11-1.265 3.632 3.632 0 0 1-.843-2.367V5.14c.25.14.516.25.797.328.281.078.57.125.867.14a4.362 4.362 0 0 1-1.195-1.125c-.297-.437-.446-.984-.446-1.64 0-.328.04-.649.118-.961.093-.313.218-.61.375-.89a8.926 8.926 0 0 0 1.5 1.476 9.276 9.276 0 0 0 1.71 1.078c.61.297 1.258.523 1.946.68.687.171 1.414.273 2.18.304a3.96 3.96 0 0 1-.094-.843c0-1.016.36-1.883 1.078-2.602C11.42.367 12.295.008 13.326.008c.531 0 1.023.101 1.476.304.47.204.876.485 1.22.844A7.767 7.767 0 0 0 17.24.828c.39-.156.766-.344 1.125-.562-.14.437-.352.836-.633 1.195a3.5 3.5 0 0 1-1.008.844 6.49 6.49 0 0 0 1.102-.188c.36-.11.703-.234 1.031-.375-.25.36-.531.703-.844 1.031a6.823 6.823 0 0 1-1.007.868Z" fill="#D6D0CC"/>
	</svg>`,
    link: "https://twitter.com/itau",
    alt: "logo twitter",
  },
]

export const contactItems = [
  {
    title: "capitais e regiões metropolitanas",
    tel: "0800 728 0728",
  },
  {
    title: "demais localidades",
    tel: "0800 728 0728",
  },
]

let currentDate = new Date()
let currentYear = currentDate.getFullYear()

export const defaultAdress = {
  copy: `© ${currentYear} Itaú Unibanco Holding S.A.  CNPJ: 60.872.504/0001-23`,
  address:
    "Praça Alfredo Egydio de Souza Aranha, 100, Torre Olavo Setubal, Parque Jabaquara - CEP 04344-902 - São Paulo - Brasil",
}
